import { Component,DoCheck } from '@angular/core';
declare var $:any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements DoCheck{
 
  title = 'biofruits';
  public session:boolean = false;

  constructor(){

    this.getSession();
  }
  ngDoCheck(): void {
    this.getSession();
  }
  getSession(){
    if(localStorage.getItem("session")){
      this.session=true;
    }else{
      this.session=false;
    }
    
  }
 

  onLogin(event){
    this.getSession();
  }
}
